// @ts-nocheck
import { BlockBorderProps } from "@store/Library/Components/Toolkit/Block";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

export const defaultBorderProps: BlockBorderProps = {
    width: pxToRem(1),
    type: "solid",
    color: "common.border",
};
